import { integer } from '@vuelidate/validators';

export default {
    integer
};